// logic taken from https://stackoverflow.com/a/70746179
export function animateOddsInFixedTime ({ duration = 600, start, end, continueAnimation, callback }) {
  const range = (end * 1000 - start * 1000) / 1000 // to prevent 4.6 - 4.2 => 0.39999999999999947
  let curr = start
  const timeStart = Date.now()

  const loop = () => {
    const elaps = Date.now() - timeStart
    if (elaps > duration) {
      console.log('animateOddsInFixedTime ends')
      callback(end)
      return null
    }
    const frac = elaps / duration
    const step = frac * range

    const nextCurr = start + step

    if (nextCurr - curr > 0.01 || nextCurr > end) { // skip rendering if no visible changes
      if (nextCurr > end) {
        curr = end
      }

      curr = Math.trunc((nextCurr) * 100) / 100
      callback(curr)
    }

    if (elaps < duration && (!_.isFunction(continueAnimation) || continueAnimation())) {
      window.requestAnimationFrame(loop)
    }
  }

  window.requestAnimationFrame(loop)
}
